import { render, staticRenderFns } from "./SocialNetworkConfig.vue?vue&type=template&id=009dc9e7&"
import script from "./SocialNetworkConfig.vue?vue&type=script&lang=js&"
export * from "./SocialNetworkConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports